import { Component } from '@angular/core';
import { NgStyle } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { SHOW_BETA_CTA } from '../landing.config';
import { AppEnvironmentHandler, environment } from '../../environments/environment';
import { AppVersionPanelComponent } from "@contexts/jovdk-web";

interface Feature
{
    n: string;
    color: string;
    title: string;
    body: string;
    showCode: boolean;
}

@Component({
    selector: 'full-app',
    imports: [NgStyle, FormsModule, AppVersionPanelComponent],
    templateUrl: './full-app.component.html',
    styleUrl: './full-app.component.css',
})
export class FullAppComponent
{
    readonly showBetaCta = SHOW_BETA_CTA;
    readonly hasToShowWaitList = false;
    // readonly navLogoIconUrl = `${environment.CDN_URL}/public/_app/features/generic/logo/013-envheaven-logo-02@0.25x.png`;
    readonly navLogoIconUrl = `${environment.WEB_SITE_01_CDN_01_FULL_URL}/public/_app/features/generic/logo/013-envheaven-logo-02@0.25x.png`;
    // readonly backgroundLogoUrl = `${environment.WEB_SITE_01_CDN_01_FULL_URL}/public/_app/features/generic/logo/013-envheaven-logo-02.png`;
    readonly backgroundLogoUrl = `${environment.WEB_SITE_01_CDN_01_FULL_URL}/public/_app/features/generic/logo/013-envheaven-logo-02.svg`;
    readonly currentYear = new Date().getFullYear();

    readonly Y = '#F5C518';
    readonly R = '#E63946';
    readonly B = '#4A6FE3';
    readonly O = '#FF6B35';

    email = '';
    status: 'idle' | 'submitting' | 'success' | 'error' = 'idle';
    statusMessage = '';

    constructor(private http: HttpClient) { }

    ngOnInit(): void
    {

        AppEnvironmentHandler.DoIfLocal(() =>
        {
            console.log('Environment Variables:', environment);
        })

        //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
        //Add 'implements OnInit' to the class.

        const words = ["Developer", "Designer", "Creator", "Innovator"];
        let index = 0;
        const element = document.getElementById('typewriter');

        if (element)
        {
            setInterval(() =>
            {
                index = (index + 1) % words.length;
                element.textContent = words[index];
                // Restart animation for varying word lengths
                element.style.animation = 'none';
                void element.offsetWidth; // Trigger reflow
                // element.style.animation = null;
                element.style.animation = null as any;
            }, 4000); // Sync this with your CSS animation duration
        }
        else
            console.error('Typewriter element not found');
    }

    readonly features: Feature[] = [
        {
            n: '01',
            color: this.Y,
            title: 'Local-first parity',
            body: "Your local environment runs exactly like production. No more 'works on my machine' excuses. If it works here, it works everywhere.",
            showCode: true,
        },
        {
            n: '02',
            color: this.R,
            title: 'CI/CD handoff',
            body: 'Seamlessly transition from local development to your automated pipelines. Deterministic environments power your test suites and deployments.',
            showCode: false,
        },
        {
            n: '03',
            color: this.B,
            title: 'AI-ready context',
            body:
                'Want to spawn 30x AI assistants? 30x different tasks? Give each one a copy of your infrastructure topology. They can run in parallel, switch environments seamlessly, without network conflicts or stepping on each other\'s dependencies.',
            showCode: false,
        },
    ];

    readonly localLogoFallback = 'assets/envheaven-logo.png';

    onLogoError(event: Event): void
    {
        const img = event.target as HTMLImageElement;
        if (img.src !== this.localLogoFallback)
            img.src = this.localLogoFallback;
    }

    onEmailSubmit(): void
    {
        if (!this.email?.trim()) return;
        if (this.status !== 'idle') return;
        this.status = 'submitting';
        this.statusMessage = '';

        this.http
            .post<{
                message?: string;
                error?: string;
                // }>(`${environment.API_URL}/api/waitlist`, { email: this.email.trim() })
            }>(`${environment.WEB_SITE_01_API_SERVER_01_FULL_URL}/api/waitlist`, { email: this.email.trim() })
            .subscribe({
                next: (res) =>
                {
                    this.status = 'success';
                    this.statusMessage = res.message || 'Check your inbox!';
                },
                error: (err) =>
                {
                    this.status = 'error';
                    this.statusMessage =
                        err.error?.error ||
                        'Something went wrong. Please try again.';
                    setTimeout(() =>
                    {
                        this.status = 'idle';
                        this.statusMessage = '';
                    }, 4000);
                },
            });
    }
}
